import * as React from "react";
import {
    Box,
    Button,
    Divider,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import ArrowOutward from "@mui/icons-material/ArrowOutward";
import AddCircleOutline from "@mui/icons-material/AddCircleOutline";
import CtaButton from "../buttonWithArrow";
import { CurrencySimple, useResponsiveValue } from "../../utils/helper";


export default function VehicleCard({
    title,
    image,
    seats,
    luggage,
    fuel,
    features = [],
    priceText, pricePerHour,
    onBook, index, modelId
}) {
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: 4,
                border: "1px solid #dfdfdf",
                px: { xs: 2, md: 3 },
                py: { xs: 2, md: 2.5 },
                mb: 3
            }}
        >
            <Stack
                direction={{ xs: "column", md: "row" }}
                alignItems={{ xs: "stretch", md: "center" }}
                spacing={{ xs: 2, md: 3 }}
            >
                {/* Left: image tile */}
                <Box
                    sx={{
                        width: { xs: "100%", md: 220 },
                        height: { xs: 170, md: 170 },
                        borderRadius: 4,
                        background: 'linear-gradient(180deg, #75c4c5 0%, #0d8196 100%)',
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                    }}
                >
                    <Box
                        component="img"
                        alt={title}
                        src={image}
                        sx={{
                            width: "88%",
                            // width: "85%",
                            // height: "85%",
                            height: "auto",
                            objectFit: "contain",
                        }}
                    />
                </Box>

                {/* Middle: title + specs */}
                <Stack flex={1} spacing={1.25}>
                    <Typography
                        sx={{ fontWeight: 800, fontSize: { xs: 18, md: 22 }, lineHeight: 1.2 }}
                    >
                        {title}
                    </Typography>

                    <Stack
                        direction={{ xs: "column", md: "row" }}
                        alignItems={{ xs: "stretch", md: "stretch" }}   // make columns equal height on desktop
                        spacing={{ xs: 2, md: 3 }}
                        sx={{ position: "relative" }}
                    >
                        {/* LEFT: spec card */}
                        <Paper
                            variant="outlined"
                            sx={{
                                flex: 1,
                                borderRadius: 4,
                                border: "1px solid #dfdfdf",
                                bgcolor: "#f2f2f2",
                                p: { xs: 1.25, md: 1.5 },
                                // minHeight: 170,                               // matches your mock
                            }}
                        >
                            {/* Capacity */}
                            <Row
                                label="Capacity :"
                                content={
                                    <Typography fontSize={14}>
                                        {seats} Seats <Box component="span" sx={{ mx: 1 }}>•</Box>
                                        {luggage} Luggage
                                    </Typography>
                                }
                            />
                            <Divider sx={{ my: 1 }} />
                            {/* Fuel */}
                            <Row label="Fuel :" content={<Typography fontSize={14}>{fuel}</Typography>} />
                            <Divider sx={{ my: 1 }} />
                            {/* Features */}
                            <Row
                                label="Features :"
                                content={
                                    <Box
                                        display="flex"
                                        flexWrap="wrap"
                                        alignItems="center"
                                        gap={1}
                                    >
                                        {features.map((f, i) => (
                                            <Box
                                                key={i}
                                                display="flex"
                                                alignItems="center"
                                                gap={0.75}
                                                sx={{ whiteSpace: 'nowrap' }}
                                            >
                                                <AddCircleOutline sx={{ fontSize: 16 }} />
                                                <Typography fontSize={14}>{f}</Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                }
                            />

                        </Paper>

                        {/* RIGHT: price top, button bottom */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",             // <-- pushes top/bottom
                                alignItems: { xs: "flex-start", md: "flex-end" },
                                width: { xs: "100%", md: 220 },              // fixed column width on desktop
                                height: { xs: "auto", md: "100%" },          // fill row height on desktop
                                minHeight: { xs: "auto", md: "auto" },          // keep spacing on mobile too
                                gap: 2,
                                flexShrink: 0,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: { xs: 22, md: 28 },
                                    lineHeight: 1,
                                    color: "#0A0A0A",
                                    whiteSpace: "nowrap",
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                {CurrencySimple(priceText, "#0A0A0A", useResponsiveValue({ xs: 22, md: 28 }))}
                            </Typography>

                            <CtaButton
                                label="Book Now"
                                onClick={() => onBook(index, modelId, pricePerHour, priceText)}
                                sx={{ alignSelf: { xs: "stretch", md: "auto" }, position: { md: "absolute" }, bottom: 0 }}
                            />
                        </Box>
                    </Stack>

                </Stack>

                {/* Right: price + CTA */}
                {/* <Stack
                    alignItems={{ xs: "flex-start", md: "flex-end" }}
                    justifyContent="space-between"
                    spacing={1.5}
                    sx={{ minWidth: { md: 180 } }}
                >
                    <Typography
                        sx={{
                            fontWeight: 800,
                            fontSize: { xs: 22, md: 28 },
                            lineHeight: 1,
                            color: "#0A0A0A",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {priceText}
                    </Typography>
                    <CtaButton label="Book Now" onClick={() => handleBookingRide()} />
                    <Button
                        onClick={onBook}
                        disableRipple
                        sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            px: 2.5,
                            py: 1.25,
                            borderRadius: "9999px",
                            color: "#fff",
                            alignSelf: { xs: "stretch", md: "auto" },
                            background: "linear-gradient(180deg,#7fd0cb 0%,#0f7f8a 100%)",
                            boxShadow: "none",
                            "&:hover": {
                                background: "linear-gradient(180deg,#74c4bf 0%,#0e747f 100%)",
                                boxShadow: "none",
                            },
                        }}
                        endIcon={
                            <Box
                                sx={{
                                    ml: 1,
                                    width: 28,
                                    height: 28,
                                    borderRadius: "50%",
                                    bgcolor: "#fff",
                                    display: "grid",
                                    placeItems: "center",
                                }}
                            >
                                <ArrowOutward sx={{ fontSize: 18, color: "#0f7f8a" }} />
                            </Box>
                        }
                    >
                        Book Now
                    </Button>
                </Stack> */}
            </Stack>
        </Paper>
    );
}

/** small helper for the left label + right content layout in the spec panel */
function Row({
    label,
    content,
}) {
    return (
        <Stack direction="row" spacing={2}>
            <Box sx={{ minWidth: { xs: 82, md: 100 } }}>
                <Typography fontSize={14} color="text.primary">
                    {label}
                </Typography>
            </Box>
            <Box sx={{ flex: 1 }}>{content}</Box>
        </Stack>
    );
}
